import { render, staticRenderFns } from "./publishers-table.vue?vue&type=template&id=101481e8&scoped=true"
import script from "./publishers-table.vue?vue&type=script&lang=js"
export * from "./publishers-table.vue?vue&type=script&lang=js"
import style0 from "./publishers-table.vue?vue&type=style&index=0&id=101481e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101481e8",
  null
  
)

export default component.exports